'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = undefined;

var _Collapse = require('./Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Collapse2['default'];
var Panel = exports.Panel = _Collapse2['default'].Panel;


//////////////////
// WEBPACK FOOTER
// ./~/rc-collapse/lib/index.js
// module id = 508
// module chunks = 0